module.exports = __webpack_public_path__ + "img/ring_0_0_0_0.0662b11a.png";